import React from 'react';
import { storeData } from '../../data/storeData';
import StoreTemplate from '../../components/StoreTemplate';
import greenwayImg from '../../assets/images/greenwayoutside.jpg';

function Greenway() {
    return <StoreTemplate storeData={storeData.greenway} storeImage={greenwayImg} />;
}

export default Greenway; 